module.exports = __webpack_public_path__ + "img/widget-design_tickets.34c7894e.jpg";